import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Button, Container } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { clearInviteNotice } from '../../store/slices/authSlice';
import { dismissGroupWelcome } from '../../services/customerGroups';
import { groupPagePath, pendingWelcome } from './groupLabels';

/** Az új tagság utáni első bejelentkezéskor egyszer: „Üdv, <Csoport> tag!”. A bezárás a
 *  felhasználónál (szerveren) tárolódik; a regisztrációs meghívó kód hibáját is itt jelezzük. */
export default function GroupWelcomeBanner() {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const inviteNotice = useAppSelector((state) => state.auth.inviteNotice ?? null);
  const [closed, setClosed] = useState<Set<string>>(new Set());

  const pending = pendingWelcome((user?.customer_groups ?? []).filter((g) => !closed.has(g.slug)));

  const dismiss = (slug: string) => {
    setClosed((prev) => new Set(prev).add(slug));
    dismissGroupWelcome(slug).catch(() => undefined); // következő betöltéskor újra próbálható
  };

  if (!pending && !inviteNotice) return null;
  return (
    <Container maxWidth="xl" sx={{ mt: 2 }}>
      {inviteNotice && (
        <Alert severity="warning" onClose={() => dispatch(clearInviteNotice())} closeText="Bezárás" sx={{ mb: 1 }}>
          {`A regisztráció sikerült, de a csoporthoz nem tudtunk csatlakoztatni: ${inviteNotice}`}
        </Alert>
      )}
      {pending && (
        <Alert severity="success" closeText="Bezárás" onClose={() => dismiss(pending.slug)}>
          {`Üdv, ${pending.name} tag! A tagi termékeidet itt éred el.`}{' '}
          <Button
            size="small"
            component={RouterLink}
            to={groupPagePath(pending.slug)}
            onClick={() => dismiss(pending.slug)}
          >
            Tagi termékek
          </Button>
        </Alert>
      )}
    </Container>
  );
}
